// import React, { useState } from "react"
// import {
//   Card,
//   CardBody,
//   CardTitle,
//   Button,
//   Row,
//   Col,
//   Input,
//   Label,
//   Alert,
// } from "reactstrap"
// import Flatpickr from "react-flatpickr"
// import "flatpickr/dist/themes/material_blue.css"
// import { SlCalender } from "react-icons/sl"

// const DeleteSection = () => {
//   const [dateRange, setDateRange] = useState(null) // null = no date filter
//   const [mobileNumbersInput, setMobileNumbersInput] = useState("")
//   const [showConfirm, setShowConfirm] = useState(false)
//   const [actionType, setActionType] = useState("")

//   const mobileNumbers = mobileNumbersInput
//     .split(",")
//     .map(num => num.trim())
//     .filter(num => num.length > 0)

//   const hasAnyFilter = () => {
//     return (dateRange && dateRange.length === 2) || mobileNumbers.length > 0
//   }

//   const getButtonText = () => {
//     return hasAnyFilter() ? "Delete Selected" : "Delete All"
//   }

//   const handleDeleteClick = () => {
//     if (hasAnyFilter()) {
//       setActionType("selected")
//     } else {
//       setActionType("all")
//     }
//     setShowConfirm(true)
//   }

//   const confirmDelete = () => {
//     // Yahan real delete logic / API call daal dena
//     if (actionType === "all") {
//       console.log("Deleting ALL uploaded data...")
//       // Example: await api.deleteAllData()
//     } else {
//       const filters = {}
//       if (dateRange && dateRange.length === 2) {
//         const [start, end] = dateRange
//         filters.startDate = start.toISOString().split("T")[0]
//         filters.endDate = end.toISOString().split("T")[0]
//       }
//       if (mobileNumbers.length > 0) {
//         filters.mobileNumbers = mobileNumbers
//       }
//       console.log("Deleting SELECTED data with filters:", filters)
//       // Example: await api.deleteByFilters(filters)
//     }

//     // Reset after delete
//     setDateRange(null)
//     setMobileNumbersInput("")
//     setShowConfirm(false)
//     alert("Delete action completed (demo)")
//   }

//   const cancelDelete = () => {
//     setShowConfirm(false)
//   }

//   const handleReset = () => {
//     setDateRange(null)
//     setMobileNumbersInput("")
//   }

//   return (
//     <Card className="shadow border-0 rounded-3 overflow-hidden mb-4">
//       <CardBody className="p-4">
//         <div className="d-flex align-items-center mb-4">
//           <div className="avatar-sm bg-soft-danger rounded-circle d-flex align-items-center justify-content-center me-3">
//             <i className="bx bx-trash fs-4 text-danger"></i>
//           </div>
//           <h4 className="mb-0 fw-semibold">Delete Data</h4>
//         </div>

//         <Row className="g-4 align-items-end">
//           {/* Date Range */}
//           <Col lg="auto" md="auto" sm={12}>
//             <Label className="form-label fw-medium d-block mb-2">
//               Date Range (optional)
//             </Label>
//             <div
//               className="input-group"
//               style={{ minWidth: "240px", maxWidth: "280px" }}
//             >
//               <Flatpickr
//                 className="form-control border-0 dash-filter-picker shadow-sm"
//                 placeholder="Select date range..."
//                 options={{
//                   mode: "range",
//                   dateFormat: "d M, Y",
//                   maxDate: "today",
//                 }}
//                 value={dateRange || ""}
//                 onChange={selectedDates => {
//                   setDateRange(
//                     selectedDates.length === 2 ? selectedDates : null
//                   )
//                 }}
//               />
//               <div className="input-group-text border-0 text-white bg-danger">
//                 <SlCalender />
//               </div>
//             </div>
//           </Col>

//           {/* Mobile Numbers */}
//           <Col lg={4} md={6} sm={12}>
//             <Label className="form-label fw-medium d-block mb-2">
//               Mobile Numbers (comma separated, optional)
//             </Label>
//             <Input
//               type="text"
//               className="form-control shadow-sm"
//               placeholder="e.g. 9876543210, 9123456789"
//               value={mobileNumbersInput}
//               onChange={e => setMobileNumbersInput(e.target.value)}
//             />
//           </Col>

//           {/* Buttons */}
//           <Col lg="auto" md="auto" sm={12} className="d-flex gap-2 flex-wrap">
//             <Button color="danger" className="px-4" onClick={handleDeleteClick}>
//               <i className="bx bx-trash me-1"></i>
//               {getButtonText()}
//             </Button>

//             <Button
//               color="secondary"
//               outline
//               className="px-4"
//               onClick={handleReset}
//               disabled={!dateRange && !mobileNumbersInput}
//             >
//               <i className="bx bx-x me-1"></i> Reset
//             </Button>
//           </Col>
//         </Row>

//         {/* Filter hint */}
//         {hasAnyFilter() && (
//           <div className="mt-3 text-muted small">
//             Will delete data matching the selected filters
//           </div>
//         )}

//         {/* Confirmation Dialog */}
//         {showConfirm && (
//           <Alert color="warning" className="mt-4">
//             <p className="mb-3">
//               {actionType === "all" ? (
//                 <>
//                   Are you sure you want to{" "}
//                   <strong>delete ALL uploaded data</strong>?
//                 </>
//               ) : (
//                 <>
//                   Are you sure you want to <strong>delete selected data</strong>
//                   ?
//                 </>
//               )}
//             </p>
//             <div className="d-flex gap-3">
//               <Button color="danger" onClick={confirmDelete}>
//                 Yes, Delete
//               </Button>
//               <Button color="light" onClick={cancelDelete}>
//                 Cancel
//               </Button>
//             </div>
//           </Alert>
//         )}
//       </CardBody>
//     </Card>
//   )
// }

// export default DeleteSection

// import React, { useState } from "react"
// import {
//   Card,
//   CardBody,
//   CardTitle,
//   Button,
//   Row,
//   Col,
//   Input,
//   Label,
//   Alert,
// } from "reactstrap"
// import Flatpickr from "react-flatpickr"
// import "flatpickr/dist/themes/material_blue.css"
// import { SlCalender } from "react-icons/sl"

// // Real delete function import
// import { deleteData } from "../../helpers/api_helper"

// const DeleteSection = () => {
//   const [dateRange, setDateRange] = useState(null) // null = no date filter
//   const [mobileNumbersInput, setMobileNumbersInput] = useState("")
//   const [showConfirm, setShowConfirm] = useState(false)
//   const [actionType, setActionType] = useState("")
//   const [deleting, setDeleting] = useState(false)
//   const [deleteMessage, setDeleteMessage] = useState("")
//   const [deleteError, setDeleteError] = useState(null)

//   const mobileNumbers = mobileNumbersInput
//     .split(",")
//     .map(num => num.trim())
//     .filter(num => num.length > 0)

//   const hasAnyFilter = () => {
//     return (dateRange && dateRange.length === 2) || mobileNumbers.length > 0
//   }

//   const getButtonText = () => {
//     return hasAnyFilter() ? "Delete Selected" : "Delete All"
//   }

//   const handleDeleteClick = () => {
//     if (hasAnyFilter()) {
//       setActionType("selected")
//     } else {
//       setActionType("all")
//     }
//     setShowConfirm(true)
//   }

//   const confirmDelete = async () => {
//     setDeleting(true)
//     setDeleteMessage("")
//     setDeleteError(null)

//     try {
//       const filters = {}

//       if (dateRange && dateRange.length === 2) {
//         const [start, end] = dateRange
//         filters.startDate = start.toISOString().split("T")[0]
//         filters.endDate = end.toISOString().split("T")[0]
//       }

//       if (mobileNumbers.length > 0) {
//         filters.mobileNumber = mobileNumbers.join(",") // backend mein single string expect kar raha hai
//       }

//       if (actionType === "all") {
//         filters.confirmAll = true
//       }

//       const result = await deleteData(filters)

//       if (result.success) {
//         setDeleteMessage(result.message || "Delete completed successfully!")

//         // StatsCards ko refresh karne ke liye event fire karo
//         window.dispatchEvent(new CustomEvent("upload-success"))

//         // Reset form
//         setDateRange(null)
//         setMobileNumbersInput("")
//       } else {
//         setDeleteError(result.error || "Delete failed")
//       }
//     } catch (err) {
//       setDeleteError(err.message || "Something went wrong")
//     } finally {
//       setDeleting(false)
//       setShowConfirm(false)
//     }
//   }

//   const cancelDelete = () => {
//     setShowConfirm(false)
//   }

//   const handleReset = () => {
//     setDateRange(null)
//     setMobileNumbersInput("")
//   }

//   return (
//     <Card className="shadow border-0 rounded-3 overflow-hidden mb-4">
//       <CardBody className="p-4">
//         <div className="d-flex align-items-center mb-4">
//           <div className="avatar-sm bg-soft-danger rounded-circle d-flex align-items-center justify-content-center me-3">
//             <i className="bx bx-trash fs-4 text-danger"></i>
//           </div>
//           <h4 className="mb-0 fw-semibold">Delete Data</h4>
//         </div>

//         <Row className="g-4 align-items-end">
//           {/* Date Range */}
//           <Col lg="auto" md="auto" sm={12}>
//             <Label className="form-label fw-medium d-block mb-2">
//               Date Range (optional)
//             </Label>
//             <div
//               className="input-group"
//               style={{ minWidth: "240px", maxWidth: "280px" }}
//             >
//               <Flatpickr
//                 className="form-control border-0 dash-filter-picker shadow-sm"
//                 placeholder="Select date range..."
//                 options={{
//                   mode: "range",
//                   dateFormat: "Y-m-d",
//                   maxDate: "today",
//                 }}
//                 value={dateRange || ""}
//                 onChange={selectedDates => {
//                   setDateRange(
//                     selectedDates.length === 2 ? selectedDates : null
//                   )
//                 }}
//               />
//               <div className="input-group-text border-0 text-white bg-danger">
//                 <SlCalender />
//               </div>
//             </div>
//           </Col>

//           {/* Mobile Numbers */}
//           <Col lg={4} md={6} sm={12}>
//             <Label className="form-label fw-medium d-block mb-2">
//               Mobile Numbers (comma separated, optional)
//             </Label>
//             <Input
//               type="text"
//               className="form-control shadow-sm"
//               placeholder="e.g. 9876543210, 9123456789"
//               value={mobileNumbersInput}
//               onChange={e => setMobileNumbersInput(e.target.value)}
//             />
//           </Col>

//           {/* Buttons */}
//           <Col lg="auto" md="auto" sm={12} className="d-flex gap-2 flex-wrap">
//             <Button
//               color="danger"
//               className="px-4"
//               onClick={handleDeleteClick}
//               disabled={deleting}
//             >
//               <i className="bx bx-trash me-1"></i>
//               {getButtonText()}
//             </Button>

//             <Button
//               color="secondary"
//               outline
//               className="px-4"
//               onClick={handleReset}
//               disabled={!dateRange && !mobileNumbersInput}
//             >
//               <i className="bx bx-x me-1"></i> Reset
//             </Button>
//           </Col>
//         </Row>

//         {/* Filter hint */}
//         {hasAnyFilter() && (
//           <div className="mt-3 text-muted small">
//             Will delete data matching the selected filters
//           </div>
//         )}

//         {/* Confirmation Dialog */}
//         {showConfirm && (
//           <Alert color="warning" className="mt-4">
//             <p className="mb-3">
//               {actionType === "all" ? (
//                 <>
//                   Are you sure you want to{" "}
//                   <strong>delete ALL uploaded data</strong>?
//                 </>
//               ) : (
//                 <>
//                   Are you sure you want to <strong>delete selected data</strong>
//                   ?
//                 </>
//               )}
//             </p>
//             <div className="d-flex gap-3">
//               <Button
//                 color="danger"
//                 onClick={confirmDelete}
//                 disabled={deleting}
//               >
//                 {deleting ? "Deleting..." : "Yes, Delete"}
//               </Button>
//               <Button color="light" onClick={cancelDelete}>
//                 Cancel
//               </Button>
//             </div>
//           </Alert>
//         )}
//       </CardBody>
//     </Card>
//   )
// }

// export default DeleteSection

// import React, { useState } from "react"
// import {
//   Card,
//   CardBody,
//   CardTitle,
//   Button,
//   Row,
//   Col,
//   Input,
//   Label,
//   Alert,
// } from "reactstrap"
// import Flatpickr from "react-flatpickr"
// import "flatpickr/dist/themes/material_blue.css"
// import { SlCalender } from "react-icons/sl"

// // Real delete function import
// import { deleteData } from "../../helpers/api_helper"

// const DeleteSection = () => {
//   const [dateRange, setDateRange] = useState(null)
//   const [mobileNumbersInput, setMobileNumbersInput] = useState("")
//   const [showConfirm, setShowConfirm] = useState(false)
//   const [deleting, setDeleting] = useState(false)
//   const [deleteMessage, setDeleteMessage] = useState("")
//   const [deleteError, setDeleteError] = useState(null)

//   const mobileNumbers = mobileNumbersInput
//     .split(",")
//     .map(num => num.trim())
//     .filter(num => num.length > 0)

//   const hasAnyFilter = () => {
//     return (dateRange && dateRange.length === 2) || mobileNumbers.length > 0
//   }

//   const getButtonText = () => {
//     return hasAnyFilter() ? "Delete Selected" : "Delete All"
//   }

//   const handleDeleteClick = () => {
//     setShowConfirm(true)
//   }

//   const confirmDelete = async () => {
//     setDeleting(true)
//     setDeleteMessage("")
//     setDeleteError(null)

//     try {
//       const filters = {}

//       if (dateRange && dateRange.length === 2) {
//         const [start, end] = dateRange
//         filters.startDate = start.toISOString().split("T")[0]
//         filters.endDate = end.toISOString().split("T")[0]
//       }

//       if (mobileNumbers.length > 0) {
//         filters.mobileNumber = mobileNumbers.join(",")
//       }

//       // IMPORTANT: Sirf jab NO filter hai tab confirm_all bhejo
//       if (!hasAnyFilter()) {
//         filters.confirmAll = true
//       }

//       console.log("[UI] Sending delete filters:", filters)

//       const result = await deleteData(filters)

//       console.log("[UI] deleteData result:", result)

//       if (result.success) {
//         setDeleteMessage(result.message || "Delete completed successfully!")
//         // Dashboard refresh event (stats update ke liye)
//         window.dispatchEvent(new CustomEvent("data-deleted"))
//         // Reset form
//         setDateRange(null)
//         setMobileNumbersInput("")
//       } else {
//         setDeleteError(result.error || "Delete operation failed")
//       }
//     } catch (err) {
//       console.error("[UI] Delete error:", err)
//       setDeleteError("Unexpected error: " + (err.message || "Unknown"))
//     } finally {
//       setDeleting(false)
//       setShowConfirm(false)
//     }
//   }

//   const cancelDelete = () => {
//     setShowConfirm(false)
//   }

//   const handleReset = () => {
//     setDateRange(null)
//     setMobileNumbersInput("")
//   }

//   return (
//     <Card className="shadow border-0 rounded-3 overflow-hidden mb-4">
//       <CardBody className="p-4">
//         <div className="d-flex align-items-center mb-4">
//           <div className="avatar-sm bg-soft-danger rounded-circle d-flex align-items-center justify-content-center me-3">
//             <i className="bx bx-trash fs-4 text-danger"></i>
//           </div>
//           <h4 className="mb-0 fw-semibold">Delete Data</h4>
//         </div>

//         <Row className="g-4 align-items-end">
//           {/* Date Range */}
//           <Col lg="auto" md="auto" sm={12}>
//             <Label className="form-label fw-medium d-block mb-2">
//               Date Range (optional)
//             </Label>
//             <div
//               className="input-group"
//               style={{ minWidth: "240px", maxWidth: "280px" }}
//             >
//               <Flatpickr
//                 className="form-control border-0 dash-filter-picker shadow-sm"
//                 placeholder="Select date range..."
//                 options={{
//                   mode: "range",
//                   dateFormat: "Y-m-d",
//                   maxDate: "today",
//                 }}
//                 value={dateRange || ""}
//                 onChange={selectedDates => {
//                   setDateRange(
//                     selectedDates.length === 2 ? selectedDates : null
//                   )
//                 }}
//               />
//               <div className="input-group-text border-0 text-white bg-danger">
//                 <SlCalender />
//               </div>
//             </div>
//           </Col>

//           {/* Mobile Numbers */}
//           <Col lg={4} md={6} sm={12}>
//             <Label className="form-label fw-medium d-block mb-2">
//               Mobile Numbers (comma separated, optional)
//             </Label>
//             <Input
//               type="text"
//               className="form-control shadow-sm"
//               placeholder="e.g. 9876543210, 9123456789"
//               value={mobileNumbersInput}
//               onChange={e => setMobileNumbersInput(e.target.value)}
//             />
//           </Col>

//           {/* Buttons */}
//           <Col lg="auto" md="auto" sm={12} className="d-flex gap-2 flex-wrap">
//             <Button
//               color="danger"
//               className="px-4"
//               onClick={handleDeleteClick}
//               disabled={deleting}
//             >
//               <i className="bx bx-trash me-1"></i>
//               {getButtonText()}
//             </Button>

//             <Button
//               color="secondary"
//               outline
//               className="px-4"
//               onClick={handleReset}
//               disabled={!dateRange && !mobileNumbersInput}
//             >
//               <i className="bx bx-x me-1"></i> Reset
//             </Button>
//           </Col>
//         </Row>

//         {/* Filter hint */}
//         {hasAnyFilter() && (
//           <div className="mt-3 text-muted small">
//             Will delete data matching the selected filters
//           </div>
//         )}

//         {/* Confirmation Dialog with warning for Delete All */}
//         {showConfirm && (
//           <Alert color="warning" className="mt-4">
//             <p className="mb-3 fw-bold">
//               {hasAnyFilter() ? (
//                 <>Confirm deletion of selected data?</>
//               ) : (
//                 <>
//                   <strong>WARNING:</strong> This will permanently delete{" "}
//                   <strong>ALL uploaded data</strong>!
//                   <br />
//                   This action cannot be undone.
//                 </>
//               )}
//             </p>
//             <div className="d-flex gap-3">
//               <Button
//                 color="danger"
//                 onClick={confirmDelete}
//                 disabled={deleting}
//               >
//                 {deleting ? "Deleting..." : "Yes, Delete"}
//               </Button>
//               <Button color="light" onClick={cancelDelete}>
//                 Cancel
//               </Button>
//             </div>
//           </Alert>
//         )}
//       </CardBody>
//     </Card>
//   )
// }

// export default DeleteSection

import React, { useState } from "react"
import {
  Card,
  CardBody,
  CardTitle,
  Button,
  Row,
  Col,
  Input,
  Label,
  Alert,
  Spinner,
} from "reactstrap"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"
import { SlCalender } from "react-icons/sl"

// Real delete function import
import { deleteData } from "../../helpers/api_helper"

const DeleteSection = () => {
  const [dateRange, setDateRange] = useState(null)
  const [mobileNumbersInput, setMobileNumbersInput] = useState("")
  const [showConfirm, setShowConfirm] = useState(false)
  const [deleting, setDeleting] = useState(false)
  const [deleteMessage, setDeleteMessage] = useState("")
  const [deleteError, setDeleteError] = useState(null)

  const mobileNumbers = mobileNumbersInput
    .split(",")
    .map(num => num.trim())
    .filter(num => num.length > 0)

  const hasAnyFilter = () => {
    return (dateRange && dateRange.length === 2) || mobileNumbers.length > 0
  }

  const getButtonText = () => {
    return hasAnyFilter() ? "Delete Selected" : "Delete All"
  }

  const handleDeleteClick = () => {
    setDeleteMessage("")
    setDeleteError(null)
    setShowConfirm(true)
  }

  const confirmDelete = async () => {
    setDeleting(true)
    setDeleteMessage("")
    setDeleteError(null)

    try {
      const filters = {}

      if (dateRange && dateRange.length === 2) {
        const [start, end] = dateRange
        filters.startDate = start.toISOString().split("T")[0]
        filters.endDate = end.toISOString().split("T")[0]
      }

      if (mobileNumbers.length > 0) {
        filters.mobileNumber = mobileNumbers.join(",")
      }

      // Sirf jab NO filter hai tab confirm_all bhejo
      if (!hasAnyFilter()) {
        filters.confirmAll = true
      }

      console.log("[Delete UI] Sending filters:", filters)

      const result = await deleteData(filters)

      console.log("[Delete UI] deleteData result:", result)

      if (result.success) {
        setDeleteMessage(result.message || "Data deleted successfully!")
        // Dashboard/Stats ko refresh karne ke liye event
        window.dispatchEvent(new CustomEvent("data-deleted"))
        // Reset form
        setDateRange(null)
        setMobileNumbersInput("")
      } else {
        // Real backend error ko dikhao
        setDeleteError(result.error || "Delete failed - please check console")
      }
    } catch (err) {
      console.error("[Delete UI] Unexpected error:", err)
      setDeleteError(
        "Unexpected error during delete: " + (err.message || "Unknown")
      )
    } finally {
      setDeleting(false)
      setShowConfirm(false)
    }
  }

  const cancelDelete = () => {
    setShowConfirm(false)
    setDeleteError(null)
  }

  const handleReset = () => {
    setDateRange(null)
    setMobileNumbersInput("")
    setDeleteMessage("")
    setDeleteError(null)
  }

  return (
    <Card className="shadow border-0 rounded-3 overflow-hidden mb-4">
      <CardBody className="p-4">
        <div className="d-flex align-items-center mb-4">
          <div className="avatar-sm bg-soft-danger rounded-circle d-flex align-items-center justify-content-center me-3">
            <i className="bx bx-trash fs-4 text-danger"></i>
          </div>
          <h4 className="mb-0 fw-semibold">Delete Data</h4>
        </div>

        <Row className="g-4 align-items-end">
          {/* Date Range */}
          <Col lg="auto" md="auto" sm={12}>
            <Label className="form-label fw-medium d-block mb-2">
              Date Range (optional)
            </Label>
            <div
              className="input-group"
              style={{ minWidth: "240px", maxWidth: "280px" }}
            >
              <Flatpickr
                className="form-control border-0 dash-filter-picker shadow-sm"
                placeholder="Select date range..."
                options={{
                  mode: "range",
                  dateFormat: "Y-m-d",
                  maxDate: "today",
                }}
                value={dateRange || ""}
                onChange={selectedDates => {
                  setDateRange(
                    selectedDates.length === 2 ? selectedDates : null
                  )
                }}
              />
              <div className="input-group-text border-0 text-white bg-danger">
                <SlCalender />
              </div>
            </div>
          </Col>

          {/* Mobile Numbers */}
          <Col lg={4} md={6} sm={12}>
            <Label className="form-label fw-medium d-block mb-2">
              Mobile Numbers (comma separated, optional)
            </Label>
            <Input
              type="text"
              className="form-control shadow-sm"
              placeholder="e.g. 9876543210, 9123456789"
              value={mobileNumbersInput}
              onChange={e => setMobileNumbersInput(e.target.value)}
            />
          </Col>

          {/* Buttons */}
          <Col lg="auto" md="auto" sm={12} className="d-flex gap-2 flex-wrap">
            <Button
              color="danger"
              className="px-4"
              onClick={handleDeleteClick}
              disabled={deleting}
            >
              <i className="bx bx-trash me-1"></i>
              {getButtonText()}
            </Button>

            <Button
              color="secondary"
              outline
              className="px-4"
              onClick={handleReset}
              disabled={!dateRange && !mobileNumbersInput}
            >
              <i className="bx bx-x me-1"></i> Reset
            </Button>
          </Col>
        </Row>

        {/* Filter hint */}
        {hasAnyFilter() && (
          <div className="mt-3 text-muted small">
            Will delete only the data matching the selected filters
          </div>
        )}

        {/* Confirmation Dialog */}
        {showConfirm && (
          <Alert color="warning" className="mt-4">
            <p className="mb-3 fw-bold">
              {hasAnyFilter() ? (
                <>Are you sure you want to delete the selected data?</>
              ) : (
                <>
                  <strong>⚠️ DANGER:</strong> This will{" "}
                  <strong>PERMANENTLY DELETE ALL</strong> uploaded data!
                  <br />
                  This action cannot be undone.
                </>
              )}
            </p>

            {deleting && (
              <div className="text-center mb-3">
                <Spinner color="danger" size="sm" /> Deleting... Please wait.
              </div>
            )}

            <div className="d-flex gap-3 justify-content-end">
              <Button
                color="danger"
                onClick={confirmDelete}
                disabled={deleting}
              >
                {deleting ? "Deleting..." : "Yes, Delete"}
              </Button>
              <Button color="light" onClick={cancelDelete} disabled={deleting}>
                Cancel
              </Button>
            </div>
          </Alert>
        )}

        {/* Success / Error Messages */}
        {deleteMessage && (
          <Alert color="success" className="mt-4">
            {deleteMessage}
          </Alert>
        )}
        {deleteError && (
          <Alert color="danger" className="mt-4">
            {deleteError}
          </Alert>
        )}
      </CardBody>
    </Card>
  )
}

export default DeleteSection
